import { ListViewIcon } from "@/domains/icons"

import { SwitchWithLabel } from "./switch-with-label"

export const SwitchListView = ({
  checked,
  onCheckedChange,
}: {
  checked: boolean
  onCheckedChange: (value: boolean) => void
}) => {
  return (
    <SwitchWithLabel
      iconLeft={<ListViewIcon size={16} />}
      label="List view"
      checked={checked}
      onCheckedChange={onCheckedChange}
    />
  )
}
